import { createSelector } from 'reselect';

const selectPayrolls = (state: any) => state.payrolls;


export const selectPayrollsCurrentItem = createSelector([selectPayrolls], (payrolls) => payrolls.current);

export const selectPayrollsListItems = createSelector([selectPayrolls], (payrolls) => payrolls.list);

export const selectPayrollsItemById = (itemId: any) =>
    createSelector(selectPayrollsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPayrollsCreatedItem = createSelector([selectPayrolls], (payrolls) => payrolls.create);

export const selectPayrollsUpdatedItem = createSelector([selectPayrolls], (payrolls) => payrolls.update);

export const selectPayrollsReadItem = createSelector([selectPayrolls], (payrolls) => payrolls.read);

export const selectPayrollsDeletedItem = createSelector([selectPayrolls], (payrolls) => payrolls.delete);

export const selectPayrollsSearchedItems = createSelector([selectPayrolls], (payrolls) => payrolls.search);

export const selectPayrollsItemsCount = createSelector([selectPayrolls], (payrolls) => payrolls.count);

export const selectPayrollsItemsFilter = createSelector([selectPayrolls], (payrolls) => payrolls.filter);